import gsap from 'gsap';
export const fadeUp = {
  mounted(el, binding) {
    const duration = binding.value?.duration || 0.6;
    const delay = binding.value?.delay || 0;
    const distance = binding.value?.distance || 50;
    const trigger = binding.value?.trigger || 'top bottom-=100';

    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches;

    if (!prefersReducedMotion) {
      gsap.from(el, {
        y: distance,
        opacity: 0,
        duration: duration,
        delay: delay,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: trigger,
          toggleActions: 'play none none none',
        },
      });
    }
  },
};
